import Pro from "./img/pro.png";
import Job from "./img/job.png";
import Com from "./img/com.png";
import Med from "./img/med.png";

export const products = [
  {
    id: 1,
    img: Pro,
    link: "https://yason.netlify.app",
  },
  {
    id: 2,
    img: Com,
    link: "https://codematetech.netlify.app",
  },
  {
    id: 3,
    img: Job,
    link: "https://codemate-jobs.netlify.app",
  },
  {
    id: 4,
    img: Med,
    link: "https://codematemedicalwebsiteforsale.netlify.app/",
  },
];
